'use strict';

if (typeof document != 'undefined') require('babel-polyfill');

var Classnames = require('classnames');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var SuperAgent = require('superagent');

var IndexRoute = ReactRouter.IndexRoute;
var Route      = ReactRouter.Route;
var Router     = ReactRouter.Router;

var Components = require('../components');
var Global     = require('../global');

var Sidebar    = require('./sidebar.jsx');
var Content    = require('./content/content.jsx');
var Landing    = require('./content/landing.jsx');
var Guide      = require('./internal/style-guide.jsx');

import Sentry from '../../../../common-js/framework/Sentry.jsx';

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./pages.scss');
}

var DeviceImage     = Global.DeviceImage;
var ResponsiveMixin = Global.ResponsiveMixin;
var ParseAPI        = Global.ParseAPI;

var Page = React.createClass({
    mixins: [ ResponsiveMixin, LinkedStateMixin ],

    getInitialState: function() {
        return {
            payload: Payload,
        };
    },
    load: function(url) {
        var _this = this;
        
        /*     In the browser we're at / but 'logically' (as per the server's MV* design) every route/view
         *     must have a name - so we map / to /home.
         *    
         *     / is rewritten by .htaccess to /home which is then found in sitePage.urlkey by page.php */
        if (url == '/') {
            url = '/home';
        }

        var query = {
            url: url,
        };
        SuperAgent
            .get('/pages.json')
            .query(query)
            .end(function(err, res) {
                var payload = ParseAPI(query, err, res);
                if (!payload) {
                    return;
                }
                _this.setState({
                    payload: payload
                });
            });
    },
    componentDidMount: function() {
        if (!isNode) {
            this.load(this.props.location.pathname);
        }
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.location.pathname != nextProps.location.pathname) {
            this.load(nextProps.location.pathname);
        }
    },
    back: function() {
        window.history.back();
    },
    render: function() {
        var isCompanyPage = this.state.payload.sidebar || this.state.payload.page.parent;
        var back = this.state.viewportLayout != 'desktop' && isCompanyPage ?
            <button onClick={this.back} className='pg-back'>
                <DeviceImage src='global/chevrons/chevron-left-grey2.png' width="21" height="13" alt='Left arrow' />
                BACK
            </button>
        : null;
        var bodyClasses = Classnames({
            'pg-body': true,
            'pg-body-sidebar': this.state.payload.sidebar,
        });
        var tab = isCompanyPage ? 'company' : null;
        
        var landing = 'standard';
        const path = this.props.location.pathname;
        if (path.match(/full-service-overview.*/)) {
            landing = 'hidden';
        } else if (path == '/') {
            landing = 'full';
        }

        return (
            <div>
                <Components.Header tab={tab} landing={landing} title={true} />
                <div className='pages'>
                    {(this.state.viewportLayout == 'desktop' || this.state.payload.page.menupage) && this.state.payload.sidebar ?
                        <Sidebar payload={this.state.payload} location={this.props.location.pathname} />
                    : null}
                    {this.state.payload.page.name != 'dummy' && (!this.state.payload.page.menupage || this.state.viewportLayout == 'desktop') ?
                        <div className={bodyClasses}>
                            {back}
                            {this.state.viewportLayout == 'desktop' || !this.state.payload.page.menupage?
                                React.isValidElement(this.props.children) && React.cloneElement(this.props.children, { payload: this.state.payload })
                            : null}
                            {back}
                        </div>
                    : null}
                </div>
                <Components.Footer />
            </div>
        );
    },
});

var SimplePage = React.createClass({
    componentDidMount: function() {
        // TODO - check why this is commented out - does width="100%" work?
        // window.Froogaloop(jQuery('iframe')).addEvent('ready', function() {
        //     Fitvids();
        // });
    },
    render: function() {
        if (!this.props.payload.page.body) {
            return <div />;
        }
        var body = this.props.payload.page.body;

        // Page body may contain [video:123123] to insert a Vimeo video with that ID
        body = body.replace(/\[video:(\w+)\]/g, (_, vimeoID) => {
            var src = `//player.vimeo.com/video/${vimeoID}?badge=0&amp;byline=0&amp;title=0`;
            // return `<iframe src             = ${src}
            //                 width           = "654"
            //                 height          = "367"
            //                 frameborder     = "0"
            //                 allowfullscreen = ""
            //              mozallowfullscreen = ""
            //           webkitallowfullscreen = ""></iframe>`;
            return `<iframe src             = ${src}
                            width           = "100%"
                            frameborder     = "0"
                            allowfullscreen = ""
                         mozallowfullscreen = ""
                      webkitallowfullscreen = ""
                            title           = "Vimeo player"
                      ></iframe>`;
        });

        // Shameless lack of logic - sitePage.name isn't used for sidebar titles (and there isn't one for T&C page)
        var title;
        if (!this.props.payload.sidebar && this.props.payload.page.name) {
            title = (<h1>{this.props.payload.page.name.toUpperCase()}</h1>);
        }

        return (
            <div className={Classnames({
                'pg-content': 1,
                'pg-content-sidebar': this.props.payload.sidebar,
                'pg-content-noSidebar': !this.props.payload.sidebar
            })}>
                {title}
                <div dangerouslySetInnerHTML={{ __html: body }} />
            </div>
        );
    }
});

// ------------------------------------------------------------------------------

var Dummy = (props) => {
    return <div />;
};

var routes = (
    <Route path='/' component={Page}>
        <IndexRoute component={Content.Homepage} onEnter={Global.GAPageview} />

        <Route      component={Dummy}                 onEnter={Global.GAPageview} path='/the-company' />
        <Route      component={Content.Contact}       onEnter={Global.GAPageview} path='/office-furniture-dealer-los-angeles' />
        <Route      component={Content.FAQ}           onEnter={Global.GAPageview} path='/modern-contemporary-office-furniture' />
        <Route      component={Content.Finance}       onEnter={Global.GAPageview} path='/office-furniture-leasing-calculator' />
        {Landing}

        <Route path='/sentry'      component={Sentry} />
        <Route path='/guide'       component={Guide} />
        <Route path='/style-guide' component={Guide} />

        {Payload.urls.map(url => {
            return <Route key={url} path={'/' + url} component={SimplePage} onEnter={Global.GAPageview} />
        })}
    </Route>
);        

if (isNode) {
    global.routes = routes;
} else {
    var dom = (
        <Router history={Global.History}>
            {routes}
        </Router>
    );
    ReactDOM.render(dom, document.getElementById('pages'));
}



// WEBPACK FOOTER //
// ./src/pages/pages.jsx